<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { Globals } from "@/Globals";
import {
  globalsBezeichnung,
  begriffBezeichnung,
  globalsStt,
  globalsDruck,
  checkNode,
} from "@/local";

import {
  getKZValueDisplay,
  getKZValue,
  getKZTitle,
  getKennungValueDisplay,
} from "@/DataHelper";
import { showDialog } from "@/UIHelper";
import { mountedBase, BaseSetup } from "@/DataLoaderStatic";
import CalcButton from "@/components/CalcButton.vue";
import { getSiteData } from "@/NavigationHelper";

const emit = defineEmits(["back", "backDelete"]);

let timeLine = ref<boolean>(false);
let myHeight = ref<number>(600);
let bezeichnung = ref<string>("");
let name = ref<string>("");
let memo = ref<string>("");
let showPrint: boolean = false;
let printItems = ref<ALLDruck[]>([]);
const siteData = getSiteData();
let showCalc = ref<boolean>(false);
let items = ref<ListItems[]>([]);
let tab = ref<string>("");
let editAzureBeleg = ref<boolean>(false);

let kostenQuery = ref<string>("Web_Uebersicht_Reisekosten");

let varUbergabe = ref<VarUebergabe[]>([]);
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_RK_Reisezeiten",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  if (checkNode("RK_Belegerkennung")) {
    kostenQuery.value = "Web_VG_UebersichtBelegeProReise";
    editAzureBeleg.value = true;
  }
  if (siteData.aic) {
    pageParams.queryAIC = siteData.aic;
  }
  myHeight.value = window.innerHeight;
  await mountedBase(uiData, pageParams, false);
  if (!uiData.showLoading && uiData.data) {
    await refreshItems();
    addDruck();
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
function addDruck() {
  const stammTyp = globalsStt(Globals.Stt, 0, "RK_TRAVEL");
  if (stammTyp) {
    printItems.value = globalsDruck(Globals.Begriff, false, stammTyp);
  }
}
async function refreshItems() {
  items.value = [];
  if (uiData.data.length > 0) {
    timeLine.value = true;
  }
  for (let i = 0; i < uiData.data.length; i++) {
    const row = uiData.data[i];
    bezeichnung.value = getKZValueDisplay(row, "subject", uiData.columns);
    name.value = getKennungValueDisplay(row, "MITARBEITER", uiData.columns);

    showCalc = getKZValue(row, "showCalc", uiData.columns);
    let title = getKZValueDisplay(row, "abfahrt", uiData.columns);
    let title2 = getKZValueDisplay(row, "ankunft", uiData.columns);
    const subtitel = getKZValueDisplay(row, "zeit", uiData.columns);
    const subtitel1 = getKZValueDisplay(row, "ereignis", uiData.columns);
    const text = getKZValueDisplay(row, "region", uiData.columns);
    const differenz = getKZValueDisplay(row, "km", uiData.columns);
    const Abflatlong = getKZValueDisplay(row, "Abf_latlong", uiData.columns);
    if (Abflatlong) {
      title = Abflatlong[2];
    }
    const Anklatlong = getKZValueDisplay(row, "Ziel_latlong", uiData.columns);
    if (Anklatlong) {
      title2 = Anklatlong[2];
    }
    const color = getKZValueDisplay(row, "color", uiData.columns);
    const icon = getKZValueDisplay(row, "icon", uiData.columns);
    let memoLocal = getKZValueDisplay(row, "text", uiData.columns);
    if (memoLocal) {
      const titleMemo = getKZTitle(row, "text", uiData.columns);
      memoLocal = titleMemo + ": " + memoLocal;
    }
    items.value.push({
      title,
      title2,
      subtitel,
      subtitel1,
      text,
      differenz,
      divider: true,
      inset: true,
      aic: row.aic_Bew_pool,
      menu: false,
      Abflatlong,
      Anklatlong,
      icon,
      color,
      memo: memoLocal,
    });
  }
}
function onCalculated(args: any) {
  emit("backDelete");
}
function openDruckVorschau(item: any) {
  const printItem = item;
  let aic = pageParams.queryAIC;
  if (aic) {
    aic = aic;
  }
  const noSelect = true;
  showDialog({
    title: printItem.bezeichnung,
    site: "BaseDruck",
    width: 500,
    data: {
      zeitbereich: siteData.zeitbereich,
      printItem,
      aic,
      pers: false,
      noSelect,
    },
    onClose: () => {
      showPrint = false;
      return true;
    },
  });
}
async function onChangeMemo() {
  varUbergabe.value = [];
  if (memo.value) {
    varUbergabe.value.push({
      var: "WebMemo",
      type: "string",
      wert: memo.value,
      art: 1,
      user: AUApi.Current.user.user, // wirklich die user ID
      perm: false,
    });
  }
}
</script>
<template id="editorTemplate">
  <v-card :loading="uiData.showLoading" v-if="uiData.initialized">
    <v-toolbar
      density="compact"
      class="dvhBackground pl-5"
      style="color: white"
    >
      <div class="headline font-weight-light white--text">
        {{ bezeichnung }} {{ name }}
      </div>
      <v-spacer></v-spacer>
      <v-menu v-if="printItems">
        <template v-slot:activator="{ props }">
          <v-btn
            icon="mdi-printer-outline"
            variant="text"
            v-bind="props"
          ></v-btn>
        </template>

        <v-list lines="one" class="shortList" nav tile outlined elevation="12">
          <v-list-item
            class="pl-2"
            v-for="(printItem, ux) in printItems"
            :key="'ui' + ux"
            @click="openDruckVorschau(printItem)"
          >
            <v-tooltip
              :disabled="!printItem.tooltip"
              location="bottom"
              :text="printItem.tooltip"
            >
              <template v-slot:activator="{ props }">
                <v-list-item-title v-bind="props">
                  {{ printItem.bezeichnung }}
                </v-list-item-title>
              </template>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn variant="text" icon="mdi-close" @click="emit('back')"></v-btn>
    </v-toolbar>

    <v-tabs v-model="tab" density="compact" tile slim show-arrows>
      <v-tab value="one">{{
        globalsBezeichnung(Globals.Begriff, "Reise", "Reise")
      }}</v-tab>
      <v-tab value="two">{{
        globalsBezeichnung(Globals.Begriff, "Reisezeiten", "Reisezeiten")
      }}</v-tab>
      <v-tab value="three">{{
        globalsBezeichnung(Globals.Begriff, "Web_Belege", "Belege")
      }}</v-tab>
      <v-tab value="four">{{
        globalsBezeichnung(Globals.Begriff, "RK_Auszahlung", "Diäten")
      }}</v-tab>
      <v-tab value="five">{{
        globalsBezeichnung(Globals.Begriff, "Details", "Details")
      }}</v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="one" bg-color="success">
        <RkWfVorgesetzterReiseDaten
          :zeitbereichUebergabe="siteData.zeitbereich"
          :aic="siteData.aic"
          :contentHight="myHeight"
          :showMemo="!showCalc"
        />
        <v-card>
          <v-textarea
            v-if="showCalc"
            clearable
            clear-icon="mdi-close-circle"
            prepend-inner-icon="mdi-comment"
            auto-grow
            :label="globalsBezeichnung(Globals.Begriff, 'Memo', 'Notiz')"
            :name="globalsBezeichnung(Globals.Begriff, 'Memo', 'Notiz')"
            variant="outlined"
            density="compact"
            color="warning"
            persistent-hint
            hide-details
            rows="1"
            v-model="memo"
            :hint="globalsBezeichnung(Globals.Begriff, 'Memo', 'Notiz')"
            @update:modelValue="onChangeMemo"
            class="px-4 pt-0"
          >
          </v-textarea>

          <v-card-actions class="pa-0" v-if="showCalc">
            <v-spacer></v-spacer>
            <CalcButton
              modell="RK_Web_ReiseFreigabeVG"
              color="success"
              icon="mdi-check"
              :zeitbereich="siteData.zeitbereich"
              :text="
                globalsBezeichnung(
                  Globals.Begriff,
                  'RK_Web_ReiseFreigabeVG',
                  'bewilligt',
                )
              "
              variant="plain"
              :modellAic="siteData.aic"
              @calculated="onCalculated"
              :varUebergabe="varUbergabe"
            />

            <CalcButton
              modell="RK_Web_ReiseAbgelehntVG"
              color="error"
              icon="mdi-close"
              variant="plain"
              :zeitbereich="siteData.zeitbereich"
              :modellAic="siteData.aic"
              :text="
                globalsBezeichnung(
                  Globals.Begriff,
                  'RK_Web_ReiseAbgelehntVG',
                  'abgelehnt',
                )
              "
              @calculated="onCalculated"
              :varUebergabe="varUbergabe"
            />
          </v-card-actions>
        </v-card>
      </v-tabs-window-item>

      <v-tabs-window-item value="two" bg-color="success">
        <v-timeline density="compact" v-if="timeLine" class="pb-5">
          <v-timeline-item
            v-for="(item, index) in items"
            :key="'c' + index"
            size="small"
            :color="item.color"
            :icon="item.icon"
          >
            <v-card :min-width="370" class="pa-2">
              <div class="caption" style="color: green">
                {{ item.subtitel }}
              </div>

              <v-card-text class="px-0 pb-0">
                <div
                  style="text-align: left"
                  class="caption"
                  v-if="item.subtitel1"
                >
                  {{
                    globalsBezeichnung(
                      Globals.Begriff,
                      "RK_REISEEREIGNISSE",
                      "Ereignis",
                    )
                  }}: {{ item.subtitel1 }}
                </div>
                <v-expansion-panels
                  tile
                  focusable
                  collapse-icon="mdi-chevron-down"
                  class="pa-0 pt-2 ma-0"
                >
                  <v-expansion-panel v-if="item.title && item.Abflatlong">
                    <v-expansion-panel-title>
                      <span
                        >Abfahrtsort: {{ item.Abflatlong[4] }}
                        {{ item.Abflatlong[5] }}</span
                      >
                    </v-expansion-panel-title>

                    <v-expansion-panel-text style="text-align: left">
                      <v-card variant="text">
                        <v-card-text style="text-align: left" class="caption">
                          <div>Land: {{ item.Abflatlong[3] }}</div>
                          <div>PLZ: {{ item.Abflatlong[4] }}</div>
                          <div>Ort: {{ item.Abflatlong[5] }}</div>
                          <div>Strasse: {{ item.Abflatlong[6] }}</div>
                          <div>Hausnummer: {{ item.Abflatlong[7] }}</div>
                        </v-card-text>
                        <template v-slot:actions>
                          <v-spacer></v-spacer>
                          <v-menu
                            open-on-click
                            top
                            offset-y
                            v-if="item.Abflatlong"
                            :close-on-click="true"
                            :close-on-content-click="false"
                          >
                            <template v-slot:activator="{ props }">
                              <v-btn
                                variant="text"
                                icon="mdi-map-marker-outline"
                                size="small"
                                v-bind="props"
                              >
                              </v-btn>
                            </template>
                            <v-card max-width="350" min-height="350">
                              <EditGps
                                :standort="{
                                  lat: item.Abflatlong[0],
                                  lng: item.Abflatlong[1],
                                  name: item.Abflatlong[2],
                                }"
                              ></EditGps>
                            </v-card>
                          </v-menu>
                        </template>
                      </v-card>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel v-if="item.title2 && item.Anklatlong">
                    <v-expansion-panel-title>
                      <span
                        >{{
                          globalsBezeichnung(
                            Globals.Begriff,
                            "Web_Zielort",
                            "Zielort",
                          )
                        }}
                        : {{ item.Anklatlong[5] }}
                      </span>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text style="text-align: left">
                      <v-card variant="text">
                        <v-card-text style="text-align: left" class="caption">
                          <div>Land: {{ item.Anklatlong[3] }}</div>
                          <div>PLZ: {{ item.Anklatlong[4] }}</div>
                          <div>Ort: {{ item.Anklatlong[5] }}</div>
                          <div>Strasse: {{ item.Anklatlong[6] }}</div>
                          <div>Hausnummer: {{ item.Anklatlong[7] }}</div>
                        </v-card-text>
                        <template v-slot:actions>
                          <v-spacer></v-spacer>
                          <v-menu
                            open-on-click
                            top
                            offset-y
                            v-if="item.Anklatlong"
                            :close-on-click="true"
                            :close-on-content-click="false"
                          >
                            <template v-slot:activator="{ props }">
                              <v-btn
                                variant="text"
                                icon="mdi-map-marker-outline"
                                size="small"
                                v-bind="props"
                              >
                              </v-btn>
                            </template>
                            <v-card max-width="350" min-height="350">
                              <EditGps
                                :standort="{
                                  lat: item.Anklatlong[0],
                                  lng: item.Anklatlong[1],
                                  name: item.Anklatlong[2],
                                }"
                              ></EditGps>
                            </v-card>
                          </v-menu>
                        </template>
                      </v-card>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
                <div
                  style="text-align: left"
                  class="caption"
                  v-if="item.title && !item.Abflatlong"
                >
                  {{
                    globalsBezeichnung(
                      Globals.Begriff,
                      "Web_Abfahrt",
                      "Abfahrt",
                    )
                  }}:
                  {{ item.title }}
                </div>
                <div
                  style="text-align: left"
                  class="caption"
                  v-if="item.title2 && !item.Anklatlong"
                >
                  {{
                    globalsBezeichnung(
                      Globals.Begriff,
                      "Web_Zielort",
                      "Zielort",
                    )
                  }}:
                  {{ item.title2 }}
                </div>
                <div
                  v-if="item.memo"
                  style="text-align: left"
                  class="caption"
                  v-html="item.memo"
                ></div>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-tabs-window-item>

      <v-tabs-window-item value="three" bg-color="success">
        <RkWfVorgesetzterDialogKosten
          :query="kostenQuery"
          :zeitbereichUebergabe="siteData.zeitbereich"
          :aic="siteData.aic"
          :contentHight="myHeight"
          :siteData="{
            editAzureBeleg: editAzureBeleg,
          }"
        />
      </v-tabs-window-item>
      <v-tabs-window-item value="four" bg-color="success">
        <!--Kosten der Reise-->
        <RkWfVorgesetzterDialogKosten
          query="Web_Uebersicht_Reisekosten"
          :zeitbereichUebergabe="siteData.zeitbereich"
          :aic="siteData.aic"
          :contentHight="myHeight"
        />
      </v-tabs-window-item>

      <v-tabs-window-item value="five" bg-color="success">
        <RkWfVorgesetzterReiseDatenDetails
          query="Web_ReiseDatenVG_Details"
          :zeitbereichUebergabe="siteData.zeitbereich"
          :aic="siteData.aic"
          :contentHight="myHeight"
        />
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>
